export default {"src":"/_next/static/media/hour-glass.932695cd.svg","height":513,"width":513};